import { Injectable } from "@angular/core";
import { ToastsManager } from "ng2-toastr";


@Injectable()
export class ErrorHandlerProvider {

    constructor(public toastr:ToastsManager) { }

    interceptError(error: any, module: string) {
        let content = error && error._body && typeof error._body == 'string' ? JSON.parse(error._body) :
            error && error.message ? error :
            { message: 'Erro interno no sistema. Contate o administrador' };

        return this.showMessage(
            this.getMessageType(error && error.status ? error.status : 500),
            `Erro no módulo ${module}`,
            content.message
        );
    }

    showMessage(type, title, message, options?){
        this.toastr[type](message, title, options);
    }

    getMessageType(status){
        switch(true) {
            case status >= 1 && status < 200: return 'info';
            case status < 300: return 'success';
            case status < 400: return 'info';
            case status < 500: return 'warning';
            default: return 'error';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/errorHandler.provider.ts